import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const numericPrice = parseFloat(product.price);
  const numericOriginalPrice = parseFloat(product.originalPrice);
  const isSale = product.originalPrice && numericOriginalPrice > numericPrice;

  return (
    // --- THIS IS THE CHANGE ---
    // The link now points to "/product/" followed by the product's ID.
    <Link to={`/product/${product.id}`} className="product-card-link">
      
      <div className="">
        <div className="product-card__image-wrapper">
          <img src={product.image} alt={product.name} />
          {isSale && <span className="product-card__sale-badge">ON SALE</span>}
        </div>
        <div className="product-card__info">
          <div className="product-card__header">
            <h3 className="product-card__name">{product.name}</h3>
            <div className="product-card__price">
              {isSale && <span className="product-card__price--original">{numericOriginalPrice.toFixed(2)} Dh</span>}
              <span className="product-card__price--current">{numericPrice.toFixed(2)} Dh</span>
            </div>
          </div>
          <p className="product-card__description">{product.subtitle}</p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;